/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as tz from 'dayjs/plugin/timezone';
import { EncryptionService } from '../services/encryption.service';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

dayjs.extend(utc);
dayjs.extend(tz);
@Injectable()
export class SetInterceptorService implements HttpInterceptor {
  private readonly platformId = inject(PLATFORM_ID);
  address: any;

  constructor(
    private _encryptionSerivce: EncryptionService,
    private translate: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    // console.log(req, 'req');
    return next.handle(clonedReq); 
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<unknown>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    let guestTokenKey;
    if (isPlatformBrowser(this.platformId)) {
      guestTokenKey = sessionStorage.getItem(environment.guestTokenKey) ? sessionStorage.getItem(environment.guestTokenKey) : '';
    }
    const token: string | null = storageKey ? storageKey : null;
    const latitute = localStorage.getItem('latitude');
    const longitute = localStorage.getItem('longitude');

    // eslint-disable-next-line @typescript-eslint/no-explicitany
    let authReq: any;
    const selectedLanguage =
          localStorage.getItem(environment.selectedLang);
    const currentLanguage = this.translate.currentLang;
    const finalLanguage = selectedLanguage || currentLanguage || 'en';
    
    const headers = {
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token}` : `Guest ${guestTokenKey}`,
      timeZone: dayjs.tz.guess(),
      lang: finalLanguage,
      latitude: Number(latitute),
      longitude: Number(longitute),
      date: dayjs().valueOf().toString()
    };

    // eslint-disable-next-line prefer-const
    authReq = req.clone({
      headers: new HttpHeaders({
        hash: this._encryptionSerivce.encryptHeaders(headers),
        deviceType: 'web',
        language: this.translate.currentLang || '',
        timeZone: dayjs.tz.guess(),
        date: dayjs().valueOf().toString()
      })
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put'
    ) {
      if (req.url.includes('Upload/uploadFiles')) {
        // Do nothing
      } else {
        // Log payload before encryption
        authReq['body'] = {
          hash: this._encryptionSerivce.encryptionPayload(
            JSON.stringify(authReq.body)
          )
        };
      }
    }
    return authReq;
  }
}
